import React from 'react';
import VarahiLogo from './VarahiLogo';

const PAGES = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'services', label: 'Services' },
  { id: 'mining', label: 'Mining' },
  { id: 'diamonds', label: 'Diamonds' },
  { id: 'renewables', label: 'Renewables' },
  { id: 'ecotourism', label: 'Eco Tourism' },
  { id: 'africa', label: 'Africa Ops' },
  { id: 'projects', label: 'Projects' },
  { id: 'team', label: 'Team' },
  { id: 'partners', label: 'Partners' },
  { id: 'news', label: 'News' },
  { id: 'gallery', label: 'Gallery' },
  { id: 'careers', label: 'Careers' },
  { id: 'contact', label: 'Contact' },
];

const Navbar = ({ currentPage, onNavigate }) => (
  <nav className="navbar">
    <div className="navbar-logo" onClick={() => onNavigate('home')}>
      <VarahiLogo size={44} />
      <div className="logo-text-wrap">
        <span className="logo-name">VARAHI</span>
        <span className="logo-tagline">Global Consulting</span>
      </div>
    </div>
    <div className="navbar-links">
      {PAGES.map(p => (
        <button
          key={p.id}
          className={`nav-btn${currentPage === p.id ? ' active' : ''}`}
          onClick={() => onNavigate(p.id)}
        >
          {p.label}
        </button>
      ))}
    </div>
  </nav>
);

export default Navbar;
